<template>
  <v-dialog v-model="vDialogShow" max-width="1000px" hpersistent>
    <v-card>
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12">
            <h1>{{$t("message.searchCompanyDialog.title")}}</h1>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="4">
            <mp-label>{{$t("message.searchCompanyDialog.label.companyName")}}</mp-label>
          </v-col>
          <v-col cols="8" outlined tile>
            <mp-input-box min>
              <v-text-field
                v-model="form.companyName"
                hide-details
                solo
                dense
                maxlength="100"
              ></v-text-field>
            </mp-input-box>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0">
            <p class="mb-0">{{$t("message.searchCompanyDialog.notes.companyName")}}</p>
            <p>{{$t("message.searchCompanyDialog.notes.clubOfficialMedia")}}</p>
          </v-col>
        </v-row>
        <v-row justify="end" class="pa-2">
          <v-col cols="6" md="2" class="py-1">
            <mp-button min wide @click="goSearch">{{$t("message.searchCompanyDialog.button.search")}}</mp-button>
          </v-col>
        </v-row>
        <template v-if="search.show && search.list.length > 0">
          <v-row class="search-result" justify="center">
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="search.list"
                item-key="companyId"
                fixed-header
                mobile-breakpoint=0
                hide-default-footer
                class="elevation-1"
                :page.sync="search.paging.page"
                :items-per-page="search.paging.itemsPerPage"
                @page-count="search.paging.pageCount = $event"
              >
                <template v-slot:item="{ item }">
                    <tr @click="clickCompany(item)">
                      <td>
                        {{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}
                      </td>
                      <td>
                        {{ item.companyName }}
                      </td>
                    </tr>
                </template>
              </v-data-table>
              <div class="text-center pt-2">
                <v-pagination color="#0F9956" circle v-model="search.paging.page"
                              :length="search.paging.pageCount"></v-pagination>
              </div>
            </v-col>
          </v-row>
        </template>

        <template v-else-if="search.show && search.list.length === 0">
          <v-row justify="center">
            <v-col cols="12">
              <p>
                {{$t("message.searchCompanyDialog.table.message.searchNoData")}}
              </p>
            </v-col>
          </v-row>
        </template>

        <v-row justify="center">
          <v-col cols="12">
            <hr/>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col
            cols="12"
            class="text-center"
          >
            <mp-button @click="vDialogShow = false">{{ $t('message.searchCompanyDialog.button.close') }}</mp-button>
          </v-col>
        </v-row>

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/message'
import { SearchCompany } from '@/api'
import MpButton from '@/components/item/MpButton.vue'
import MpInputBox from '@/components/item/MpInputBox'
import MpLabel from '@/components/item/MpLabel'

export default {
  components: {
    MpInputBox,
    MpLabel,
    MpButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    onlyAccountEntryGroup: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    headers: [
      { text: i18n.t('message.searchCompanyDialog.table.label.group'), value: 'groupName', sortable: false, width: '50%' },
      { text: i18n.t('message.searchCompanyDialog.table.label.company'), value: 'companyName', sortable: false, width: '50%' }
    ],
    form: {
      companyName: ''
    },
    search: {
      show: false,
      list: [
      ],
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    }
  }),
  computed: {
    vDialogShow: {
      get () {
        return this.show
      },
      set (newVal) {
        this.init()
        this.$emit('change-show', newVal)
      }
    }
  },
  methods: {
    init () {
      this.search.show = false
      this.search.list = []
      this.search.paging.page = 1
      this.form.companyName = ''
    },
    async goSearch () {
      this.search.list = await SearchCompany.search(
        {
          ...this.form,
          onlyAccountEntryGroup: this.onlyAccountEntryGroup
        }
      )
      this.search.show = true
    },
    clickCompany (compnay) {
      this.$emit('select-company', compnay)
      this.vDialogShow = false
    }
  }
}
</script>

<style scoped>
  .search-result tbody tr {
    cursor: pointer;
  }
</style>
